import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./index.scss";
// import Header from '@/components/header'
// import { Bscroll } from '@/components/bscroll'
import { connect } from "react-redux";
import config from "@/config";
import { privacyChangeDev, emailChangeDev } from "@/utils/privacydev";
const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});
const PrivacyText = (props) => {
  let company = props.tenant;
  let history = useHistory();
  let [plate, setPlate] = useState("美团、哈啰等聚合打车平台");
  // let [plate, setPlate] = useState('滴滴开放平台')
  return (
    <div className="privacy-text__box">
      {/* <Header tit={`《${company}隐私协议》`}/> */}
      <div className="privacy__show">
        {/* <Bscroll scrollX={false} scrollY={true} bounce={{bottom:false}}> */}
        <div className="text__show">
          <h2>隐私政策</h2>
          <h5>2021年06月22日版本</h5>
          <h5>2021年06月22日生效</h5>
          <p>
            “{company}”的开发者为“{privacyChangeDev()}”。{company}
            非常重视用户隐私的保护。本隐私政策适用于{company}手机客户端和
            {config.isYW ? "美团、哈啰等聚合打车平台" : "滴滴开放平台"}（指：
            {company}将其接入
            {config.isYW ? "美团、哈啰等聚合打车平台" : "滴滴出行平台"}
            ，用户可以通过
            {config.isYW ? "美团、哈啰等聚合打车平台" : "滴滴出行平台"}入口享受
            {company}
            提供的网约车服务的平台）产品及服务。请您务必认真阅读本政策，在确认充分了解并同意后使用
            {company}
            。如果您/您的监护人不同意本隐私政策的任何内容，您应该立即停止使用。当您开始使用
            {company}
            ，即表示您/您的监护人已经问意我们按照本政策来收集、保存、使用、共享、保护您的个人信息。
          </p>
          {/* <p>
          <span
              onClick={() => {
                history.push("/sdkstate");
              }}
              style={{ color: "rgb(37, 133, 251)" }}
            >
              点击查看第三方SDK情况说明
            </span>
          </p> */}
          <p>本隐私政策主要包括以下内容：</p>
          <p className="text__show_indent">1.个人信息的定义与范围；</p>
          <p className="text__show_indent">2.个人信息的收集；</p>
          <p className="text__show_indent">3.我们如何使用Cookie及同类技术；</p>
          <p className="text__show_indent">4.个人信息的保存；</p>
          <p className="text__show_indent">5.个人信息的使用；</p>
          <p className="text__show_indent">
            6.个人信息的共享、转让、公开披露；
          </p>
          <p className="text__show_indent">7.用户权利；</p>
          <p className="text__show_indent">8.未成年人保护；</p>
          <p className="text__show_indent">9.变更；</p>
          <p className="text__show_indent">10.如何联系我们。</p>
          <span className="tit_span">1.个人信息的定义与范围</span>
          <p>
            1.1
            个人信息，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息。
          </p>
          <p>
            1.2
            个人敏感信息，是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
          </p>
          <p>
            1.3
            匿名化处理后的信息，即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息，匿名化处理后的信息不属于个人信息。
          </p>
          <p>
            1.4
            其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。
          </p>
          <span className="tit_span">2.个人信息的收集</span>
          <p>
            2.1 在您使用{company}服务前，需要在{company}
            创建账号并完善个人资料。通过用户主动授权提供的方式，我们会收集您的以下信息：
          </p>
          <p>
            2.1.1 您需要向我们提供您的手机号码，并设置您在{company}
            的用户密码。我们以此识别您在{company}的网络身份，并为您提供{company}
            服务。如果您拒绝提供手机号码，{company}
            将无法为您创建账号并提供服务。
          </p>
          <p>
            2.1.2 如果您是驾驶员用户，我们将收集您以下信息：
          </p>
          <p>
            2.1.2.1
            您必须向我们提供姓名、身份证或其他身份证明、面部识别特征、车辆照片、车辆品牌、型号、颜色、车牌号、驾驶证、行驶证、车辆监督卡信息、银行卡信息，我们还需要查询您的信用信息、是否有犯罪记录、是否有不良行为记录或其他不适宜作为驾驶员的情形。我们将通过读取SD卡获得您的身份证明图片、车辆图片用于审核您是否符合网约车司机的要求。我们收集上述信息，是基于法律法规要求以及保护平台用户人身财产安全之需要。如果您拒绝提供上述信息，将无法作为
            {company}的驾驶员用户向其他用户提供服务。
          </p>
          <p>
            2.1.2.2
            您可以添加紧急联系人。添加紧急联系人时，您可手动输入紧急联系人的姓名、手机号，也可以通过授权
            {company}
            读取通讯录的方式直接上传紧急联系人信息。您添加紧急联系人后，使用一键报警功能时，行程信息会通过短信自动分享给紧急联系人。如您拒绝提供紧急联系人信息，会导致您无法实时分享您的行程以达到保护自身安全的目的。
          </p>
          <p>
            2.1.2.3
            位置信息。获得您的允许后，我们会通过IP地址、GPS以及能够提供相关信息的其他传感器（如会通过
            {company}
            提供附近设备、Wi-Fi接入点和基站信息）来获取您的位置信息，以便定位您的位置，为您发送附近的订单。如果您拒绝
            {company}获取位置信息，您将无法作为驾驶员用户使用{company}服务。
          </p>
          <p>
            2.1.2.4
            行程信息。我们将通过记录用户行为收集您的出发地、到达地、行踪轨迹、时长及里程数信息。我们收集上述信息，是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷之需要。如果您拒绝我们获取您的行踪轨迹，将导致您无法作为驾驶员用户向乘客提供服务。
          </p>
          <p>
            2.1.2.5 录音信息。为提升{company}产品安全能力、更好地处理{company}
            的司乘纠纷，{company}舒适性、商务型、或{company}
            其他上线录音功能的服务，将通过软件或硬件设备录取您行程中的车内环境声音信息（包括您及车上人员交谈或肢体动作产生的声音）。受技术条件影响，
            {company}各项服务在不同城市上线录音功能的时间不同，具体以{company}
            显示的录音状态为准。录音起始时间、保存规则等，以{company}
            与您另行达成的具体协议约定为准。
          </p>
          <p>
            2.1.2.6
            录像信息。部分平台内注册车辆可能安装有车内视频记录仪等设备，您使用
            {company}
            产品或服务过程中可能被录制视频信息。我们留存上述信息，是基于地方性法律法规要求，或用于用户发生纠纷或安全事故时，核实事实并处理投诉。录像起始时间、保存规则等，以
            {company}与您另行达成的具体协议约定为准。
          </p>
          <p>
            2.1.2.7
            订单信息及交易状态。我们将记录您的订单信息及交易状态。我们收集上述信息是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷之需要。
          </p>
          <p>
            2.1.2.8
            我们还会收集您在接单状态下的驾驶行为信息（例如是否超速行驶、是否长时间手持接打电话或进行其他妨碍驾驶安全的行为），并对您进行提醒，以减少驾驶员用户违反交通规则或者平台规则的不良驾驶行为。
            如果您使用租赁车辆在{company}
            接单，经您授权后，我们会与您承租车辆的租赁公司共享您的驾驶行为信息，以方便租赁公司为您提供安全驾驶提示服务。
          </p>
          <p>
            2.1.2.9 您通过{company}
            接打电话、发送短信时，我们会收集您的通话内容、通话时长、主被叫手机号码信息，以及您通过
            {company}发送的文字信息内容。为更好保护用户安全，{company}
            不直接向用户提供其他用户的手机号码等联系方式，因此用户只能通过
            {company}
            进行通话或信息沟通。我们通过通话录音的方式留存上述信息，以便用户发生纠纷或安全事故时，核实事实并处理投诉。如果您拒绝我们获取您的通话信息，可能导致您无法使用
            {company}的通话及信息功能。
          </p>
          <p>
            2.2您在{company}进行交易支付时，如果您使用第三方支付功能，{company}
            将获取您的支付工具、支付账户风控信息以及支付状态。如果您使用
            {company}钱包功能，您需要设置您在{company}
            的支付密码，我们将记录您的余额、支付记录、提现记录以及银行卡号。我们收集上述信息以核实乘客是否按约支付费用、驾驶员是否违规收费，维护平台交易秩序，并按照平台规则处理用户纠纷。如果您拒绝我们获取您的银行卡号，您将无法使用
            {company}钱包的提现功能，但不影响您使用{company}其他服务。
          </p>
          <p>
            2.3 当您与{company}
            客服团队联系时，我们会以通话录音及人工录入的方式记录您的通话信息、您提出的意见或建议、您提供的姓名、联系方式，以便我们处理纠纷、解决问题或向您反馈结果。如果您拒绝我们收集此类信息，会导致您无法拨打我们的客服电话或客服团队无法将处理结果反馈到您，但不影响您使用
            {company}其他业务功能。
          </p>
          <p>
            2.4
            您参加我们的运营活动时，我们需要您提供某些信息，可能会包含您的姓名、照片、通讯地址、联系方式、银行卡号。这些信息可以帮助我们对活动结果进行公示，对活动进行后续宣传，与您取得联系，向您发放礼品或转账。如果您拒绝提供此类信息，可能导致无法参加相应活动，或无法收到礼品、转账，但不会影响您使用
            {company}其他业务功能。
          </p>
          <p>
            {/* 2.5 为开展数据分析和更好改善{company}服务，我们会收集您的日志信息，包括检索内容、IP地址、设备信息（包括设备型号、设备识别码、SIM卡IMSI信息、操作系统、系统语言、分辨率、电信运营商、SIM卡归属地），做出特征模型并进行用户画像，以为您提供更加个性化、便捷的服务。我们会使用浏览器网络存储机制和应用程序数据缓存，在您的设备上收集信息并进行本地存储。<br /> */}
            2.5 您通过{company}
            使用第三方服务时直接向第三方提供的个人信息，或授权{company}
            共享给第三方的个人信息，将适用该第三方的隐私保护政策。当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或像素标签不受我们的控制，且它们的使用不受本政策的约束。我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施。请您在使用前仔细阅读他们的隐私保护政策，以判断是否继续使用该第三方服务。
          </p>
          <p>
            2.6
            请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且需要收集您的信息，我们会通过页面提示、交互流程、网站公告、另行签署协议等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
          </p>
          <p>
            2.7 
            为了防控运营风险，保障您的账号安全，满足法律法规要求，开展数据分析、更好改善服务，我们会收集您的设备信息（包括设备型号、设备序列号、操作系统版本、设备设置、MAC 地址及 IMEI、IDFA、OAID、ANDROID_ID及其他设备标识符、SIM 卡 IMSI 信息、SIM 卡归属地、设备环境、移动应用列表及其他软硬件特征信息）、位置信息及日志信息（包括浏览记录、检索内容、点击查看记录、交易记录以及 IP 地址、浏览器类型、电信运营商、使用语言、访问日期和时间）。
          </p>
          <span className="tit_span">3.我们如何使用Cookie及同类技术</span>
          <p>
            3.1
            Cookie是支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制。当您使用
            {company}
            产品或服务时，为使您获得更轻松安全的访问体验，我们可能会使用Cookie或同类技术来收集和存储信息，在此过程中可能会向您的设备发送一个或多个Cookie或匿名标识符。这么做是为了收取您的信息用于了解您的偏好，进行咨询或数据分析，改善产品服务及用户体验，或及时发现并防范安全风险，为您提供更好的服务。我们不会将Cookie用于本政策所述目的之外的任何用途，您可根据自己的偏好留存或删除Cookie。您可清除软件内保存的所有Cookie，当您手动清除后您的相关信息即已删除。
          </p>
          <p>
            3.2我们平台上还可能包含一些电子图像（以下简称“单像素GIF文件”或“网络Beacon"），使用网络Beacon可以计算浏览网页的用户或访问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如：Internet协议（P）地址，浏览器类型，Internet服务提供商（ISP），参考/退出页面，操作系统，日期/时间戳，和点击数据流等。
          </p>

          <span className="tit_span">4 个人信息的保存</span>
          <p>4.1 信息保存期限</p>
          <p>
            4.1.1 在用户使用{company}服务期间，我们会持续保存用户的个人信息。
          </p>
          <p>
            4.1.2
            当您自主删除个人信息或注销账户，我们将按照法律、法规规定的最短期限保留您的现有个人信息，在法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。当您的个人信息超出上述保存期限，我们将会对其进行匿名化处理。
          </p>
          <p className="text__show_indent">
            a.为配合人民检察院、公安机关、国家安全机关侦查用户使用{company}
            服务过程中产生的犯罪行为，更好保护其他用户生命财产安全，当用户自主删除个人信息或注销账户，我们将在刑法规定的犯罪追诉时效期间内，加密隔离存档用户个人信息。
          </p>
          <p className="text__show_indent">
            b.如您使用{company}
            服务的过程中，存在严重违反法律法规、平台协议、平台规则等情形，您的违法、违约记录及相应的平台信用记录，将被永久保存。
          </p>
          <p className="text__show_indent">
            c.{company}
            与您另行签署的具体的隐私协议就某类信息的保存期限做特殊约定的，从其约定。
          </p>
          <p>4.2 信息存放地域</p>
          <p>4.2.1 我们收集的您的个人信息，将在中国内地存储和使用。</p>
          <p>
            4.2.2
            如涉及向境外传输个人信息，我们将明确向您告知个人信息出境的目的、接收方、安全保障措施等情况，并另行征得您的同意。
          </p>
          <p>4.3 安全保护措施</p>
          <p>
            4.3.1
            本公司将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不丢失、泄露、毁损或被未经授权的访问、使用。
          </p>
          <p>4.3.2 {company}采取以下安全技术措施保护您的个人信息：</p>
          <p className="text__show_indent">
            a.用户个人信息被加密储存在服务器中，并通过数据隔离技术进行存储。
          </p>
          <p className="text__show_indent">b.数据传输过程中使用加密传输协议。</p>
          <p className="text__show_indent">
            c.严格控制数据访问权限，设立完善的敏感数据访问权限申请、审批制度。
          </p>
          <p className="text__show_indent">d.建立数据安全监控和审计制度，进行全面数据安全控制。</p>
          <p>4.3.3 {company}同时采取其他安全措施保护您的个人信息：</p>
          <p className="text__show_indent">
            a.建立公司信息安全委员会，统一协调管理数据安全工作，并下设数据安全小组、推动各项数据安全活动。
          </p>
          <p className="text__show_indent">
            b.公司内部颁布实施数据安全管理规范，明确对用户数据（包括用户个人信息）的保护标准和要求。
          </p>
          <p className="text__show_indent">
            c.新项目、新系统上线前对数据安全（包括用户个人信息数据）进行项目风险评估。
          </p>
          <p className="text__show_indent">
            d.与全体员工及服务外包人员签署保密协议，并严格按照工作职责分配数据访问权限。
          </p>
          <p className="text__show_indent">e.定期开展面向公司全体员工及外包服务人员的信息安全教育及培训。</p>
          <p>4.4 安全事件处置</p>
          <p>
            4.4.1
            为应对个人信息泄露、毁损、丢失等可能出现的安全风险，已经在公司范围内颁布多项制度，明确了安全事故、安全漏洞的分类分级标准，以及针对上述安全事故和漏洞，内部处理流程（包括应急响应流程）和补救措施。
          </p>
          <p>
            4.4.2
            一旦发生安全事件，我们将及时向您告知事件基本情况和风险、我们已经采取或将要采取的措施、您如何自行降低风险的建议等。{" "}
          </p>
          <p>
            4.4.3
            我们将及时以推送通知、信函或电话等方式将安全事件情况通知受影响的用户。当难以逐一告知用户时，我们将通过发布平台公告的方式发布警示信息。
          </p>
          <p>4.5 停止运营</p>
          <p>
            4.5.1 如{company}停止运营，我们将至少提前30日在{company}
            发布公告，并及时停止收集个人信息。
          </p>
          <p>
            4.5.2
            停止运营后，我们将停止对个人信息的商业化使用，并在满足法律法规规定的最短保存期后，对收集的个人信息进行匿名化处理。
          </p>

          <span className="tit_span">5.个人信息的使用</span>
          <p>
            5.1 您的个人信息会被用于“个人信息的收集”条款明确列明的使用场景。
          </p>
          <p>
            5.2
            您的个人信息可能被用于以下与“个人信息的收集”条款所声称的目的具有直接或合理关联的场景：
          </p>
          <p className="text__show_indent">
            {/* a.我们可能将来自{company}某项服务的个人信息与来自其他项服务的信息结合起来，做出特征模型并进行用户画像，以为您提供更加个性化、便捷的服务。我们承诺在使用用户画像的过程中，不会侵害公民、法人和其他组织的合法权益，不会危害国家安全、荣誉和利益。<br /> */}
            a.我们可能以用户个人信息统计数据为基础设计、开发、推广全新的产品及服务。
          </p>
          <p className="text__show_indent">
            b.我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息。
          </p>
          <p className="text__show_indent">
            c.我们会向您发送信息和通知，包括但不限于为保证服务完成所必需的验证码、使用产品或服务时所必要的推送通知
          </p>
          <p>
            {/* 、关于{company}服务的新闻以及市场活动及优惠促销信息、{company}合作第三方的推广信息，或其他您可能感兴趣的内容。如您不希望继续接收上述信息，可以根据信息中提供的退订方式予以退订。<br /> */}
            5.3
            凡是超出与“个人信息的收集”条款声称目的具有直接或合理关联的范围使用您的个人信息，我们会再次向您告知并征得您的明示同意。
          </p>
          <p>
            5.4
            另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意：
          </p>
          <p className="text__show_indent">a.与国家安全、国防安全直接相关的；</p>
          <p className="text__show_indent">b.与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p className="text__show_indent">c.与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p className="text__show_indent">
            d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>
          <p className="text__show_indent">e.所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
          <p className="text__show_indent">
            f.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；{" "}
          </p>
          <p className="text__show_indent">g.其他法律法规等规定的情形。</p>

          <span className="tit_span">6. 个人信息的共享、转让、公开披露</span>
          <p>
            6.1 共享是指{company}
            向其他个人信息控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。
            {company}不会对外共享您的个人信息，但以下情况除外：
          </p>
          <p>
            6.1.1 在获取明确同意情况下的共享：获得您的明确同意后，{company}
            会向您指定的第三方共享您授权范围内的信息。
          </p>
          <p>
            6.1.2 在法定情形下的共享：{company}
            可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
          </p>
          <p>
            6.1.3您通过第三方平台（包括
            {config.isYW
              ? "美团、哈啰等聚合打车平台"
              : "滴滴出行 、花小猪打车、百度地图、腾讯地图等"}
            ）使用“{company}”服务时，我们将采取如下措施： <br />
            6.1.3.1
            我们需要将您的<span className="light">手机号、身份证（正反面照片）、驾驶证（正页和副页）</span>共享给第三方平台，以便第三方平台对您的网约车驾驶员及车辆资格进行核验。
          </p>
          <p>
            6.1.3.2
            我们需要将您的<span className="light">位置信息，车辆信息（车辆颜色，车型，司机服务年限，司机昵称，司机头像和司机接单数）</span>共享给第三方平台，以便更快速有效的完成订单撮合；
          </p>
          <p>
            6.1.3.3
            当发生严重事故、纠纷时，我们需要将您的<span className="light">姓名、手机号、行程轨迹、行程录音</span>共享给第三方平台，以便第三方平台与司机联系，协助解决纠纷。
          </p>
          <p>
            6.1.3.4
            在为司机分配订单时，我们需要将您的<span className="light">身份证号</span>共享给第三方平台，以便第三方平台核验司机是否符合第三方平台的安全要求。
          </p>
          <p>
            6.1.3.5如果基于流行病学等公共安全事件的调查（下称“流调”）的需要，流调机关或政府监管部门向第三方平台提出流调信息调取求，我们可能根据防疫需求，将您的<span className="light">手机号</span>共享给第三方平台，由第三方平台进行订单信息的匹配，并将匹配后生成的司乘信息，即行程轨迹、订单信息提供给相关的流调机关或政府监管部门。
          </p>
          <p>
            6.1.3.6
            为保证向乘客提供更安全的网约车服务，第三方平台会不定期或随机对我们的安全执行措施进行抽查，届时我们会将相关您的<span className="light">身份证、驾驶证信息</span>共享给第三方平台。
          </p>
          <p>
            “{company}
            ”向第三方平台提供上述个人信息前，将保障上述信息不用于其它场景。且会与共享个人信息的公司、组织和个人签署严格的保密协议，要求他们严格按照本政策声明的目的使用个人信息以及采取相关的保密和安全措施来处理个人信息。
          </p>
          <p>
            6.1.4 共享给{company}的关联公司：您的信息可能会在{company}
            的关联公司内共享。例如，对于使用同一套账户体系的业务，我们会在关联公司内共享您的<span className="light">账户信息（账户、密码、昵称及其他用户基础资料）</span>；出于维护平台秩序、保护平台或其他用户合法权利的需要，我们会在关联公司内共享用户违法、违约、违反平台规则的行为。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
          </p>
          <p>
            6.1.5 共享给业务合作伙伴：{company}
            可能会向合作伙伴等第三方共享您的个人信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴包括：
          </p>
          <p className="text__show_indent">
            a.您通过{company}使用第三方服务时，{company}
            会按照“个人信息的收集”条款列明的共享内容与提供服务的第三方共享您的个人信息。
          </p>
          <p className="text__show_indent">
            b.广告、分析服务类的授权合作伙伴。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。
          </p>
          <p className="text__show_indent">
            c.如果您通过{company}参加第三方举办或者{company}
            与第三方联合举办的营销、推广活动，{company}
            需要与第三方共享您的<span className="light">姓名、手机号码、收货地址、银行卡号</span>或者其他必要的信息，以方便第三方统计活动参与情况、获奖情况，为您绑定您获取的优惠券、发放权益、邮寄您获取的奖品等。
          </p>
          <p className="text__show_indent">
            d.供应商、服务提供商或其他合作伙伴。{company}
            可能会将您的个人信息共享给支持我们功能的第三方，包括为我们提供基础设施技术服务、实名验证服务及其他身份验证服务、人脸识别服务、支付服务、数据处理服务的第三方等。我们共享这些信息的目的是为实现产品及服务的功能，比如我们需要将您的姓名和身份证号共享给实名验证服务供应商，以进行实名验证；或者我们需要与人脸识别供应商共享您的面部识别特征及姓名、身份证号，以识别您是否本人使用服务；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。
            {company}
            会与共享个人信息的公司、组织和个人其签署严格的保密协议，要求他们严格按照本政策声明的目的使用个人信息以及采取相关的保密和安全措施来处理个人信息。
          </p>
          <p>
            6.1.6
            为维护用户合法权益，在协助处理与您有关的交易纠纷或争议时，我们可能向您的交易相对方或存在利害关系的第三方提供解决交易纠纷或争议所必需的信息。
          </p>
          <p>
            6.2
            如发生收购、兼并、重组等变更，我们会要求变更后的主体依然遵守本隐私政策约定，履行原有责任及义务。如变更后的主体需变更个人信息使用目的，我们会要求其事先获得您的明示同意。对内而言，在之前的收购、兼并活动中，对于被收购、被兼并对象管理的数据（包括用户数据）均采用与
            {company}自有数据相同的标准和要求进行处理和保护。
          </p>
          <p>
            6.3
            我们将遵守相关法律法规，对您的个人信息予以保密。除非事先获得您的明确同意或授权，或依照法律规定所必须，我们不会公开披露您的个人信息。
          </p>
          <p>
            6.4
            另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：
          </p>
          <p className="text__show_indent">a.与国家安全、国防安全直接相关的；</p>
          <p className="text__show_indent">b.与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p className="text__show_indent">c.与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p className="text__show_indent">
            d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>
          <p className="text__show_indent">e.个人信息主体自行向社会公众公开的个人信息；</p>
          <p className="text__show_indent">
            f.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
          </p>
          <p>6.5 存储权限说明</p>
          <p>我们将请求您的存储权限获取外置存储信息(SD卡数据)，您可以在开启本地存储权限后，使用该功能上传您的照片/图片，以实现身份、驾驶证、车辆证明等证明。</p>
          <p>6.6 剪切板信息说明</p>
          <p>在你分享或接收被分享的信息时，需要在本地访问你的剪切板.读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。</p>
          <p>6.7 我们所接入的第三方软件开发工具包（SDK）</p>
          <p>
            为保障“{company}
            ”车主APP相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的。关于第三方如何收集、使用您的个人信息，建议您参考第三方SDK的相关服务协议及个人信息保护政策。如果您希望进一步了解我们所接入的第三方SDK情况,请您阅读下文提供的隐私政策地址。<br />
            {/* <span
              onClick={() => {
                history.push("/sdkstate");
              }}
              style={{ color: "rgb(37, 133, 251)" }}
            >
              请您阅读第三方SDK情况说明
            </span>
            。 */}
          </p>
          <p>Bugly Android：SDK名称：Bugly Android 开发者：深圳市腾讯计算机系统有限公司 <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：安卓系统需要使用 android.permission.INTERNET 和 android.permission.ACCESS_NETWORK_STATE 权限，用于查看网络状态，进行数据上报，实现开发者查看崩溃信息的目的。这些权限会在进程启动阶段及Crash闪退时调用，用于上传日志，属于必选权限。iOS系统需要网络权限，同样用于查看网络状态、数据上报和开发者查看崩溃信息，在进程启动阶段及Crash闪退时调用，属于必选权限。</p>

          <p>人脸离线识别SDK：SDK名称：人脸离线识别SDK（Face_SDK） 开发者：北京百度网讯科技有限公司 <a href="https://ai.baidu.com/ai-doc/REFERENCE/Akdyizf5t" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：设备信息（操作系统信息）、IP地址（用于生成设备硬件指纹Device ID，实现SDK联网激活）、图片信息（用于进行人脸识别）。使用的设备权限包括：拍摄权限（用于采集人脸图片，仅在本地完成识别，不与云端交互）、读取电话状态权限（用于获取设备IMSI/IMEI，生成设备ID进行本地SDK鉴权）、读取/写入外部存储卡权限（用于存储人脸图片或特征值信息，仅在本地完成识别）。这些权限需要用户授权才能开启，用户可以随时在系统中取消授权，但可能导致部分功能无法正常使用。在不同设备中，权限显示及关闭方式可能有所不同，请参考设备及系统的说明或指引。</p>

          <p>人脸离线采集SDK：SDK名称：人脸离线采集SDK 开发者：北京百度网讯科技有限公司 <a href="https://ai.baidu.com/ai-doc/REFERENCE/Ckdym0tc9" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：人脸离线采集SDK用于实现人脸图像采集和活体验证功能，需要收集以下个人信息：设备信息(包括设备型号、操作系统信息)、IP地址(用于生成设备硬件指纹Device ID，实现SDK联网激活)、图片信息和视频信息(用于进行人脸识别和活体验证)。使用的设备权限包括：相机权限(用于采集人脸图片和视频，仅在本地完成识别)、麦克风权限(用于视频录制时的音频采集)、读取/写入外部存储卡权限(用于存储人脸图片或特征值信息)、网络访问权限(用于数据传输和活体核验)、位置权限(通过IP地址获取粗略位置用于检验设备环境)。这些权限需要用户授权才能开启，用户可以随时在系统中取消授权，但可能导致部分功能无法正常使用。所有人脸图像和视频信息将加密存储在本地，不上传至云端(除非开发者另有配置)。在不同设备中，权限显示及关闭方式可能有所不同，请参考设备及系统的说明或指引。</p>

          <p>对象存储OSS Android SDK：SDK名称：对象存储OSS Android SDK 开发者：阿里云计算有限公司 <a href="https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：对象存储OSS Android SDK用于实现文件上传下载和存储管理功能，需要收集基本设备信息(包括设备型号和操作系统信息)，用于改进应用使用体验。使用的设备权限主要包括：网络访问权限(android.permission.INTERNET，必选权限，用于发起网络访问请求，实现数据传输功能)，以及存储权限(android.permission.WRITE_EXTERNAL_STORAGE和android.permission.READ_EXTERNAL_STORAGE，可选权限，用于读取本地文件上传到对象存储、下载对象存储文件到本地，以及在断点续传时保存断点记录信息)。SDK内部集成了第三方组件Okhttp3(由Square, Inc提供)用于处理网络请求，但不会通过该组件收集或共享任何个人信息。这些权限需要用户授权才能开启，用户可以随时在系统中取消授权，但可能导致部分功能无法正常使用。在不同设备中，权限显示及关闭方式可能有所不同，请参考设备及系统的说明或指引。</p>

          <p>微信OpenSDK Android：SDK名称：微信OpenSDK Android 开发者：深圳市腾讯计算机系统有限公司 <a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：微信OpenSDK Android用于实现应用内与微信的功能对接，包括分享内容到微信、使用微信登录和微信支付等功能。SDK需要收集的信息包括：用户在第三方应用中主动选择分享的图片或内容(用于分享功能)、用户授权后的微信头像和昵称(用于登录功能)、支付订单标识和支付状态信息(用于支付功能)，以及在Android系统中验证设备上微信APP的安装状态。SDK需要使用的权限主要包括：网络访问权限(用于与微信服务器通信)和在iOS系统中的剪切板权限(用于实现应用间信息传输)。所有个人信息仅用于实现相关功能，不会用于关联和追踪用户，且存储于中国境内，仅保留必要时间。用户可以随时在系统中拒绝相关授权，但可能导致相应功能无法正常使用。</p>
          
          {/* <p>极光推送：SDK名称：极光推送 - JPush SDK - Android 开发者：深圳市和讯华谷信息技术有限公司 <a href="https://www.jiguang.cn/license/privacy" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p> */}
          {/* <p>权限说明：极光推送SDK用于为应用提供消息推送、数据分析和用户画像功能，需要收集的个人信息包括：设备标识符(Android ID、GAID、OAID、UAID、IDFA等，用于生成设备唯一标识确保准确统计)、设备硬件信息(设备型号、屏幕分辨率、硬件制造商等，用于确保兼容性和行为分析)、网络信息(网络类型、运营商信息、IP地址、基站信息，用于判断连接状态和数据分析)以及软件列表信息(用于用户画像和精准营销)。SDK使用的必选权限包括：INTERNET(联网和数据上报)、ACCESS_NETWORK_STATE(检测联网方式优化传输)、POST_NOTIFICATIONS(Android 13及以上设备显示通知)和JPUSH_MESSAGE(广播权限校验)；可选权限包括：存储权限(避免同用户生成多个推送ID)、位置权限(地理围栏推送和用户分群)、读取手机状态权限(生成唯一标识符)、VIBRATE(通知振动功能)等。此外，SDK具有应用自启动功能，通过获取软件列表及运行信息，及时分析用户行为和偏好，提供精准营销策略。用户可根据需求选择授予可选权限，但必选权限是确保推送服务正常运行所必需的。</p> */}
          <p>SDK名称：极光推送 SDK</p>
          <p>第三方主体：深圳市和讯华谷信息技术有限公司</p>
          <p>合作目的：为 APP 用户提供信息推送服务</p>
          <p>处理个人信息类型及用途：设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID、Boot ID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、DHCP、WIFI状态信息）、推送信息日志：必要个人信息，用于推送服务基本业务功能场景中生成脱敏的终端用户设备唯一性标识，保证服务在不同设备上的兼容性和准确识别，同时了解推送信息送达的情况。设备标识符（包括IMEI、MAC、IMSI）：可选个人信息，用于推送服务基本业务功能场景中生成终端用户设备唯一标识的补充，提升唯一设备标识的准确性，进而提升推送的精确度和触达率；网络信息（包括SSID、BSSID、WIFI列表信息、基站信息、SIM卡状态）：可选个人信息，用于推送服务基本业务功能场景中判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。位置相关信息：地理围栏、用户分群推送、用户洞察扩展功能所必要个人信息，用于提供线下场景的精细化推送，根据位置信息推荐更符合您需要的推送内容；软件列表信息（包括软件列表及软件运行列表信息）：用户分群、应用自启动、链路调节器、用户洞察扩展功能所必要个人信息：有助于帮助您洞察您终端用户的兴趣偏好，帮助您为用户提供更合适的推送内容，同时优化SDK长连接稳定性，提升推送送达率及应用活跃度及通过合并链路，达到为用户省电省流量的目的。</p>
          <p>数据处理方式：通过去标识化、加密传输及其他安全方式</p>
          <p>极光隐私权政策链接：《AURORA 极光隐私政策》</p>
          <p>官网链接：<a style={{ color: "rgb(37, 133, 251)" }} href="https://www.jiguang.cn/">https://www.jiguang.cn/</a></p>

          <p>SDK名称：科大讯飞 离线语音合成SDK</p>
          <p>功能场景：语音播报</p>
          <p>处理目的：为 APP 用户语音播报服务</p>
          <p>服务提供方：科大讯飞股份有限公司</p>
          <p>联系方式：dpo@iflytek.com</p>
          <p>获取权限：蓝牙权限、读写权限、网络权限、音频播放权限</p>
          <p>收集个人信息类别：语音信息、文本信息、设备信息（设备号（IMEI号）、设备码（IMSI码）、IP地址、Android ID（安卓唯一设备ID以提供能力授权服务）、中国移动UAID（仅限安卓设备）、OAID（仅限安卓设备）、UUID（仅限iOS设备）、mac地址（仅限Linux设备））、日志信息</p>
          <p>隐私政策链接：<a style={{ color: "rgb(37, 133, 251)" }} href="https://www.xfyun.cn/doc/tts/offline_tts/offline_tts_sdkprivacy.html">https://www.xfyun.cn/doc/tts/offline_tts/offline_tts_sdkprivacy.html</a></p>

          <p>腾讯地图SDK：SDK名称：腾讯地图SDK（Android） 开发者：深圳市腾讯计算机系统有限公司 <a href="https://privacy.qq.com/document/preview/a10a8634f237464da9a95f4f07e73e40" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：腾讯地图SDK为了提供高质量的地图服务，需要收集并处理部分设备信息。在Android系统中，我们会收集网络类型（用于防止网络变化导致地图加载失败）、设备型号（确保SDK兼容不同手机厂商）、屏幕密度和尺寸（防止显示错误）、操作系统版本（避免系统接口差异导致崩溃）、IP地址（建立连接及问题处理）、OAID（用户定位和反作弊）、正在运行的进程名（排查崩溃问题）、SSID（提供地图服务）和SD卡信息（缓存地图数据节省流量）。所有信息通过HTTPS加密传输或仅本地使用不上传。必要系统权限包括网络访问(INTERNET)和网络状态检查(ACCESS_NETWORK_STATE)，可选权限为外部存储读写(WRITE_EXTERNAL_STORAGE)，用于兼容旧安卓系统的地图缓存。请注意，OAID为可选信息，拒绝提供必要信息将导致无法正常使用地图服务。权限申请时机由开发者应用决定，您可随时通过设备系统设置管理权限。</p>
          <p>必须权限说明：android.permissiOn.INTERNET，使用目的在遮挡区域卫星定位失效是需要使用网络定位，网络定位需要基站信息，获得路线及路况信息，若无此权限，无法定位，无法实现导航功能</p>

          <p>腾讯定位SDK：SDK名称：腾讯定位SDK（Android） 开发者：深圳市腾讯计算机系统有限公司 <a href="https://privacy.qq.com/document/preview/dbd484ce652c486cb6d7e43ef12cefb0" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：腾讯定位SDK 用于为用户提供精确或粗略的位置服务，在使用过程中需要收集设备相关信息。在Android系统中，SDK会收集OAID(用于用户定位和反作弊)、系统属性和操作系统版本(处理不同系统的定位策略)、系统设置(处理位置服务开关状态)、设备型号(兼容不同厂商手机)、运营商基站信息、WIFI信息(包括WiFi状态、参数、附近WiFi列表和已连接WiFi)、传感器信息(包括重力、陀螺仪、加速度、磁场和旋转矢量传感器，用于辅助定位和预测定位点)、蓝牙信息、精确位置信息(GPS)、BSSID、SSID、SIM卡状态、网络运营商名称及手机制式信息。在iOS系统中，会收集IDFV、操作系统版本、设备型号、WIFI信息、传感器信息、蓝牙信息、设备运动数据及精确位置信息等。所有这些信息均通过HTTPS加密传输。SDK需要申请的必要权限包括精确和粗略位置权限(ACCESS_FINE_LOCATION和ACCESS_COARSE_LOCATION)以及网络权限(INTERNET)，这些权限对于基本定位功能是必需的；可选权限包括蓝牙扫描权限、网络与WIFI状态权限、前台服务权限和后台定位权限。需要特别说明的是，位置信息属于敏感个人信息，如拒绝提供可能导致定位服务精度受损；传感器信息为可选收集项，开发者可自主决定是否收集；SDK提供了隐私信息请求开关，可根据需求配置。</p>

          <p>腾讯导航SDK：SDK名称：腾讯导航SDK（Android） 开发者：深圳市腾讯计算机系统有限公司 <a href="https://privacy.qq.com/document/preview/ba5687d1f4054fed8e108645255320f7" style={{ color: "rgb(37, 133, 251)" }}>SDK隐私政策链接</a></p>
          <p>权限说明：腾讯导航SDK为提供精确定位、路线规划和导航服务，需要收集用户设备相关信息。SDK会收集网络类型、设备型号、操作系统版本、屏幕参数等基本设备信息，用于确保地图正常加载和显示；收集精确位置信息(GPS)、WIFI信息、基站信息、蓝牙信息等，用于提供准确的定位和导航服务；收集传感器数据(包括重力、陀螺仪、加速度等)，用于辅助定位和预测定位点。在Android系统中，SDK需要网络访问和网络状态检查权限(必选)，以及外部存储读写权限(用于地图缓存)和位置权限；在iOS系统中，需要位置权限。所有收集的信息均通过HTTPS加密传输或仅本地使用。请注意，位置信息属于敏感个人信息，如拒绝提供将无法使用定位和导航功能。SDK提供了可选权限控制开关，您可根据实际需求配置。SDK还集成了腾讯智能平台TTS组件用于导航语音播报，该组件在本地处理数据不涉及个人信息上传。</p>

          {/* <p>科大讯飞：我们集成了科大讯飞用于向用户提供语音播报功能，科大讯飞将收集您的<span className="light">设备名称、设备型号、操作系统版本、手机屏幕信息、操作系统信息、设备硬件型号、手机绑定时间、绑定设备数、“讯飞AI学”App应用安装列表信息、IMEI、DFV(iOS)、CCID(Android)、IMSI(Android)、唯一设备识别码(AndroidID/IDFA/OPENUDID/GUID)等</span></p>
          <p>百度地图：我们集成高德地图SDK用于为用户提供路线规划、导航等相关功能。百度地图会收集您的<span className="light">Android_ID、WiFi_SSID、Mac地址、IMEI、openid、位置信息,获取网络状态、访问Wi-Fi状态、位置信息、访问粗略位置、访问精准定位、读取手机状态和身份、读取外置存储器、写入外置存储器权限、写入SD卡等信息</span></p>
          <p>高德地图：我们集成高德地图SDK用于实现热力图等相关功能，为用户</p>提供订单热量提示。高德地图会收集您的<span className="light">WiFi_SSID、IMEI、IDFA、Android ID、MEID、MAC地址、OAID、IMSI、硬件序列号、位置信息、BSSID等信息</span></p>
          <p>腾讯地图：我们集成高德地图SDK用于实现热力图等相关功能，为用户提供订单热量提示。高德地图会收集您的<span className="light">WiFi_SSID、IMEI、IDFA、Android ID、MEID、MAC地址、OAID、IMSI、硬件序列号、位置信息、BSSID等信息</span></p>
          <p>极光推送：极光推送服务为APP赋予消息和通知的推送能力。您的APP在集成极光推送SDK后，极光推送SDK会收集使用实现服务所必须的个人信息，通过加密的通道将消息和通知推送给您的终端用户。极光推送SDK收集使用的个人信息包括：<span className="light">①设备信息（IMEI、MAC、IMSI）：用于识别唯一用户，保证消息推送的精准送达；优化推送通道资源，我们会根据设备上不同APP的活跃情况，整合消息推送的通道资源，为开发者提高消息送达率；为开发者提供智能标签以及展示业务统计信息的服务；②网络信息（SSID、BSSID、WIFI列表信息、基站信息）：优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性；实现区域推送的功能；③软件列表信息：用于用户分群推送、应用自启动和链路调节器功能。；④位置相关信息：基于位置信息实现地理围栏推送和用户分群推送功能。⑤基站信息：用于判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。</span></p>
          <p>Bugly 统计：我们集成了 Bugly 以统计应用闪退情况和您在应用内的功能使用情况，以便提供更稳定、优质的服务。我们可能会收集的信息包括：<span className="light">设备型号、应用程序版本、各功能点击数、集成电路卡识别码、会话启动/停止时间、语言所在地。</span></p>
          <p><span className="light">百度人脸识别SDK、百度地图SDK、JPush SDK具有自启动功能</span>，为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为,是因实现功能及服务所必要的。本应用须使用(自启动)能力，其目的是确保推送通道的稳定性，以便正常及时地向安卓设备推送消息。当系统发送广播时，将唤醒百度人脸识别SDK、百度地图SDK、JPush SDK自启动行为。鉴于百度人脸识别SDK、百度地图SDK、JPush SDK系以集成方式接入应用，百度人脸识别SDK、百度地图SDK、JPush SDK自启动，则应用亦陆之自启动。该行为系因实现推送功能及服务所必要。</p> */}
          <p><span className="light">自启动和关联启动</span>说明:</p>
          <p>1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</p>
          <span className="tit_span">7. 用户权利</span>
          <p>7.1 访问个人信息。您可以通过以下方式在{company}访问个人信息：</p>
          <p className="text__show_indent">
            a.账户，您可以通过点击{company}
            左上角人形图像-设置-个人信息，访问您提供的个人资料、支付设置。
          </p>
          <p className="text__show_indent">
            b.订单，您可以通过点击{company}
            左上角人形图像-行程，访问您的行程信息、订单信息及交易状态。
          </p>
          <p className="text__show_indent">
            c.钱包，您可以通过点击{company}
            左上角人形图像-钱包，访问您的余额、积分、支付方式开通情况、提现方式、提现记录的情况等信息。
          </p>
          <p>
            7.2 更正个人信息。当您需要更新您的个人信息，或发现{company}
            收集、存储的个人信息有错误时，您有权做出更正或更新。您可以通过将您的更正申请提交给
            {company}客服团队，或通过以下方式在{company}自行更正或修改个人信息：
          </p>
          <p className="text__show_indent">
            a.账户，您可以通过点击{company}
            左上角人形图像-点击进入个人主页-编辑资料，更正或修改您提供的个人资料信息。
          </p>
          <p className="text__show_indent">
            b.设置，您可以通过点击{company}
            左上角人形图像-设置账号与安全，更正或修改手机号码等信息。
          </p>
          <p>
            7.3 删除个人信息。如您希望删除个人信息，可以线上或电话联系{company}
            客服，提交删除申请。在满足法律法规要求的最短保存期限要求的情况下，我们将对您的个人信息进行删除或匿名化处理。在上述法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。
            但当{company}
            存在以下情形时，您删除个人信息的申请将不受法律法规要求的最短保存期限限制：
          </p>
          <p className="text__show_indent">
            a.{company}违反法律、行政法规的规定收集、使用您的个人信息。
          </p>
          <p className="text__show_indent">
            b.{company}违反我们双方的约定收集、使用您的个人信息。
          </p>
          <p>7.4 撤回同意。我们将通过以下方式保障用户撤回同意的权利：</p>
          <p className="text__show_indent">
            a.{company}
            发送的商业广告信息中，会向您说明具体退订方式，您可以按照信息中说明的退订方式撤回同意。
          </p>
          <p className="text__show_indent">
            b.您可以通过设备的设置功能，关闭相应设备权限（包括位置、通讯录、照片、麦克风、相机、通知等），撤回对
            {company}获取您个人信息的授权。
          </p>
          <p className="text__show_indent">
            c. 您还可以通过解除银行卡绑定、删除信息等方式撤回部分授权。
            当您撤回同意或授权后，可能导致我们无法为您继续提供撤回授权部分对应的服务。但您撤回同意或授权，不影响撤回前基于您的同意开展的个人信息处理。
          </p>
          <p>
            7.5 注销账号。您可以通过“{company}”的个人信息页面里面的设置功能的注销账号来注销在“{company}”的账号。除此之外，您可以通过在线或者电话联系{company}客服注销在{company}
            的账号，{`客服电话：${config.TEL}`}。
            。除法律法规另有规定外，注销账号之后我们将停止为您提供服务，并根据本协议约定期限保存您的个人信息，保存期限届满后我们将对您的个人信息进行匿名化处理。
          </p>
          <p>
            7.6
            如您无法通过上述方式访问、更正、删除个人信息，撤回同意或注销账号，您可以通过手机客户端的“客服”功能在线或者电话与
            {company}的客服团队取得联系
            {config.isYW ? `，客服电话：${config.TEL}` : ""}。{company}
            客服团队可能需要验证您的身份，并在验证您的身份后20日内作出答复或合理解释。
          </p>

          <span className="tit_span">8. 未成年人保护</span>
          <p>
            8.1 {company}
            非常重视对未成年人信息的保护。如果您是未满18周岁的未成年人，您的监护人需要仔细阅读本政策并授权您同意依照本政策使用
            {company}
            。如果您是未满14周岁的未成年人，您的监护人需要仔细阅读本政策并同意您依照本政策使用
            {company}。{" "}
          </p>
          <p>
            8.2 如果您/您的监护人不同意本隐私政策的任何内容，您应该立即停止使用
            {company}。
          </p>

          <span className="tit_span">9. 变更</span>
          <p>
            9.1 如{company}发生以下变化，我们将及时对本隐私政策进行相应的修订：
          </p>
          <p className="text__show_indent">a.{company}业务功能发生变更；</p>
          <p className="text__show_indent">b.用户个人信息保存地域发生变更；</p>
          <p className="text__show_indent">
            c.用户个人信息的使用规则发生变更；
          </p>
          <p className="text__show_indent">
            d.我们的联络方式及投诉渠道发生变更；
          </p>
          <p className="text__show_indent">
            e.发生其他可能影响用户个人信息安全或影响用户隐私权利的变更等。
          </p>
          <p>
            9.2 隐私政策修订后，我们会在{company}
            发布最新版本，并以推送通知或者平台公示的方式告知用户，以便用户及时了解最新版本隐私政策。
          </p>
          <p>
            9.3 未经您的明确同意，我们不会削减您按照本隐私政策所享有的权利。
          </p>

          <span className="tit_span">10. 如何联系我们</span>
          <p>
            10.1 您可以通过手机客户端的“客服”功能在线或者电话与“{company}
            ”的客服团队取得联系，反馈您的意见或投诉。
          </p>
          <p>
            10.2
            我们还设立了个人信息反馈专用邮箱，您可以将您的问题发送至以下邮箱：82269008@qq.com，
            {config.isYW ? `客服电话：${config.TEL}` : ""}
            ，我们将在15个工作日内核实并处理您反馈的问题。
          </p>
        </div>

        {/* </Bscroll> */}
      </div>
    </div>
  );
};
export default connect(mapStateToProps)(PrivacyText);
